export default __webpack_public_path__ + "static/media/figuremap10.0c16924d.png";